// extracted by mini-css-extract-plugin
export default {"tab_container":"Tabs_tab_container__KKVwr","tab_container_wide":"Tabs_tab_container_wide__GVojz","tab_white_space":"Tabs_tab_white_space__E3t7y"};